export default {
  en: {
    status: {
      NEEDS_TRIAGE: 'Needs attention',
      CONFIRMED: 'Confirmed',
      DISMISSED: 'Canceled',
      RESOLVED: 'Authorized'
    },
    reportStatus: {
      UNKNOWN: 'Undefined',
      INFO: 'Informational',
      MEDIUM: 'Unwanted',
      HIGH: 'Unacceptable',
      CRITICAL: 'Critical'
    },
    hasVulenarabilities: 'Has vulnerabilities',
    noVulenarabilities: 'No vulnerabilities'
  },
  ru: {
    status: {
      NEEDS_TRIAGE: 'Требует внимания',
      CONFIRMED: 'Подтвержден',
      DISMISSED: 'Отменен',
      RESOLVED: 'Разрешен'
    },
    reportStatus: {
      UNKNOWN: 'Неопределенные',
      INFO: 'Информационные',
      MEDIUM: 'Нежелательные',
      HIGH: 'Недопустимые',
      CRITICAL: 'Критические'
    },
    hasVulenarabilities: 'Есть уязвимости',
    noVulenarabilities: 'Нет уязвимостей'
  }
};
